/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from 'react';
import postal from 'postal';
import CustomerListSkyBlue from "../img/customer_not-selected_skyblue.svg";
import CustomerListNotSelectedIcon from "../img/customer-not-selected.svg";
import DashboardMenu from '../ui/dashboard/menu/DashboardMenu';
import ifmsLogo from '../img/ifms-logo-black.png';
import ifmsLogoWhite from '../img/ifms-logo_White.svg';
import { IfmsConfigMenuItem, IfmsConfigOperationMenu } from '../config/types';
import { SystemSettings, User } from '../ifmsTypes';
import { MenuFilterGrents } from '../util';
import constants from '../constants';
import ReferenceFilesNotSelectedIcon from '../img/reference-not-selected2.png';
import ReferenceFilesNotSelectedIconSkyBlue from '../img/reference-not-selected2_skyblue.svg';
import SettingsNotSelectedIcon from '../img/settings-not-selected.png';
import SettingsNotSelectedIconSkyBlue from '../img/settings-not-selected_skyblue.svg';
import ContainerTrackingIcon from "../img/container_tracking.svg";
import ContainerTrackIconSkyBlue from "../img/container_tracking-skyblue.svg";
import ExpressSearchIcon from "../img/magnifying-glass-orange3.svg";
import ExpressSearchIconDark from "../img/magnifying-glass-dark.svg";
import inbondMenuIconBlue from "../img/Inbond_B.svg";
import inbondMenuIconSkyBlue from "../img/Inbond_D.svg";
import inbondMenuIconGray from "../img/inbond_gray.svg";
import { getFmsGlobal } from '../globals';
import UserButton, { UserButtonItem } from '../ui/UserButton';
import ApplicationContext from '../ApplicationContext';
import { FmsSecTask } from '../fms.core/constants';
import supportIcon from '../img/eSupport-not-selected.svg';
import supportIconSkyBlue from '../img/eSupport-not-selected_skyblue.svg';
import { changeOperation } from '../features/operationSlice';
import { useAppDispatch } from '../app/hooks';
import config from '../config';
import AccountingNotSelected from '../img/accounting-not-selected.png';
import WarehousingNotSelected from '../img/warehousing-not-selected.png';
import OceanImportNotSelected from '../img/ocean-import-not-selected.png';
import OceanExportNotSelected from '../img/ocean-export-not-selected.png';
import AirImportNotSelected from '../img/air-import-not-selected.svg';
import AirExportNotSelected from '../img/air-export-not-selected.svg';
import TruckingOthersNotSelected from '../img/trucking-others-not-selected.png';
import FreightReceiptNotSelected from '../img/freight-receipt-not-selected.svg';
import utilitiesIcon from '../img/utilities-not-selected.svg';
import ReportManagerNotSelected from '../img/report-manager-not-selected.png';
import brokerageTruckingNotSelected from '../img/brokerage-trucking-not-selected.svg';
import RunnerIcon from '../img/runner.svg';
import ExitIcon from '../img/exit.svg';

import OceanImportNotSelectedSkyBlue from '../img/ocean-import-not-selected_skyblue.svg';
import OceanExportNotSelectedSkyBlue from '../img/ocean-export-not-selected_skyblue.svg';
import AirImportNotSelectedSkyBlue from '../img/air-import-not-selected_skyblue.svg';
import AirExportNotSelectedSkyBlue from '../img/air-export-not-selected_skyblue.svg';
import TruckingOthersNotSelectedSkyBlue from '../img/trucking-others-not-selected_skyblue.svg';
import FreightReceiptNotSelectedSkyBlue from '../img/freight-receipt-not-selected_skyblue.svg';
import WarehousingNotSelectedSkyBlue from '../img/warehousing-not-selected_skyblue.svg';
import ReportManagerNotSelectedSkyBlue from '../img/report-manager-not-selected_skyblue.svg';
import BillingsNotSelectedSkyBlue from '../img/billings-not-selected_skyblue.svg';
import AccountingNotSelectedSkyBlue from '../img/accounting-not-selected_skyblue.svg';
import utilitiesIconSkyBlue from '../img/utilities-not-selected_skyblue.svg';
import brokerageTruckingNotSelectedSkyBlue from '../img/brokerage-trucking-not-selected_skyblue.svg';

import BillingsNotSelected from '../img/billings-not-selected.svg';

import myjobNotSelected from '../img/my-job-not-select.svg';
import myjobNotSelectedSkyBlue from '../img/my-job-not-select-skyblue.svg';
import myjobNotSelectedGray from '../img/my-job-not-select-gray.svg';

import OrchidTrackingIcon from '../img/orchid_tracking.svg';
import OrchidTrackingIconSkyBlue from '../img/orchid_tracking.svg';

import taskReminderIcon from '../img/bell.svg';
import _ from 'lodash';
import Select from '../ui/Select';
import TextBoxUncontrolled from '../ui/TextBoxUncontrolled';
import { getJobNameByTbName, getOpTypeConstant, JobNames } from '../framework.core/JobNames';
import useExternalScreenFilter from '../hooks/useExternalScreenFilter';
import { useHistory } from 'react-router';
import { SearchModelBase } from '../fms.data/models/SearchModelBase';
import { moveJobToOperation } from '../features/jobMenuSlice';
import { moveScreenToOperation, moveScreenToTop } from '../features/screenStackSlice';
import { NavigationType, openNewPage as NavOpenNewPage } from '../util/navigationHelpers';
import useJobMenus from '../hooks/useJobMenus';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextBox from '../ui/TextBox';
import businessIntelligenceNotSelected from '../img/bi.svg';
import businessIntelligenceNotSelectedSkyBlue from '../img/bi_D.svg';

import amsNotSelected from '../img/AMS_B.svg';
import amsNotSelectedSkyBlue from '../img/AMS_D.svg';
import amsNotSelectedGray from '../img/AMS_gray.svg';
import aesNotSelected from '../img/AES_B.svg';
import aesNotSelectedSkyBlue from '../img/AES_D.svg';
import isfNotSelected from '../img/ISF_B.svg';
import isfNotSelectedSkyBlue from '../img/ISF_D.svg';
import isfNotSelectedGray from '../img/ISF_gray.svg';
const createMenuItem = (
  text: string,
  menuOp: string,
  icon: string,
  darkModeIcon: string,
  //hoverIcon: string,
  link: string,
  name: string,
  disable:boolean,
  disableIcon?: string,
): IfmsConfigMenuItem => ({
  text,
  menuOp,
  level: 0,
  icon: !_.isEmpty(icon) ? <img src={icon} style={getIconStyle(text)} alt="" /> : '',
  darkModeIcon: !_.isEmpty(darkModeIcon) ? <img src={darkModeIcon} style={getIconStyle(text)} alt="" /> : '',
  disableIcon: !_.isEmpty(disableIcon) ? <img src={disableIcon} style={getIconStyle(text)} alt="" /> : '',
  //hoverIcon: <img src={hoverIcon} style={getIconStyle(text)} alt="" />,
  isSelected: (o: string) => o === text,
  link,
  changeOperation: text,
  customId: text,
  changeSideMenu: text,
  name,
  disable,
});

const getIconStyle = (text: string): { height: number; width: number; } => {
  const defaultStyle: { height: number; width: number; } = { height: 14, width: 14 };
  const specialStyles: { [key: string]: { height: number; width: number; } } = {
    'Warehousing': { height: 15, width: 15 },
    'Accounting': { height: 15, width: 15 },
    'Operation Report': { height: 18, width: 15 },
    'Billings': { height: 16, width: 16 },
    'Util': { height: 17, width: 17 },
    'Customer List': { height: 18, width: 18 },
    'Reference Files': { height: 18, width: 18 },
    'Container Tracking': { height: 20, width: 20 },
    'eSupport': { height: 18, width: 18 },
    'Settings': { height: 18, width: 18 },
    'Manifest': { height: 20, width: 17 },
    'Load': { height: 20, width: 17 },
    'Local D/O': { height: 20, width: 17 },
    'In-bond': { height: 18, width: 18 },
    'Business Intelligence': { height: 20, width: 17 },
    'AMS': { height: 20, width: 17 },
    'AES': { height: 20, width: 17 },
    'ISF': { height: 20, width: 17 },
    'Orchid Tracking': {height: 20, width: 20},
  };
  return specialStyles[text] || defaultStyle;
};

const OrderMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Manifest',
    constants.operations.order,
    brokerageTruckingNotSelected,
    brokerageTruckingNotSelectedSkyBlue,
    //'',
    '/common/joblistview/btOrder/order',
    'opmenu-order',
    false
  )
];

const LoadMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Load',
    constants.operations.load,
    brokerageTruckingNotSelected,
    brokerageTruckingNotSelectedSkyBlue,
    //'',
    '/common/joblistview/btLoadPlan/load',
    'opmenu-load',
    false
  )
];

const LocalDOMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Local D/O',
    constants.operations.localDO,
    brokerageTruckingNotSelected,
    brokerageTruckingNotSelectedSkyBlue,
    //'',
    '/common/joblistview/btLocalDO/localDO',
    'opmenu-localDO',
    false
  )
];

const WarehousingMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Warehouse',
    constants.operations.warehousing,
    WarehousingNotSelected,
    WarehousingNotSelectedSkyBlue,
    //WarehousingHover,
    '/common/joblistview/whReceiving/warehousing',
    'opmenu-warehousing',
    false
  ),
];

const AMSMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'AMS',
    constants.operations.ams,
    amsNotSelected,
    amsNotSelectedSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/AMSM/ams',
    'opmenu-ams',
    false
  )
];

const AMSMenuNotUse: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'AMS',
    '',
    amsNotSelected,           
    amsNotSelectedSkyBlue,    
    //utilitiesHoverIcon,
    '',
    'opmenu-ams',
    true,
    amsNotSelectedGray
  )
];

const ISFMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'ISF',
    constants.operations.isf,
    isfNotSelected,
    isfNotSelectedSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/ISFL/isf',
    'opmenu-isf',
    false
  )
];

const ISFMenuNotUse: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'ISF',
    '',
    isfNotSelected,          
    isfNotSelectedSkyBlue,   
    //utilitiesHoverIcon,
    '',
    'opmenu-isf',
    true,
    isfNotSelectedGray
  )
];

const AESMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'AES',
    '',
    aesNotSelected,
    aesNotSelectedSkyBlue,
    //utilitiesHoverIcon,
    '',
    'opmenu-aes',
    false
  )
];

const OPReportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Operation Report',
    constants.operations.opReport,
    ReportManagerNotSelected,
    ReportManagerNotSelectedSkyBlue,
    //ReportManagerHover,
    '/opReport/estProfit?docType=705&isManagerReport=true&opType=oceanImport',
    'opmenu-opReport',
    false
  )
];

const BillingsMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Billings',
    constants.operations.billings,
    BillingsNotSelected,
    BillingsNotSelectedSkyBlue,
    //BillingsHover,
    '/common/joblistview/invoice/accounting?parentOp=billings',
    'opmenu-billings',
    false
  ),
];

const AccountingMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Accounting',
    constants.operations.accounting,
    AccountingNotSelected,
    AccountingNotSelectedSkyBlue,
    //AccountingHover,
    '/accounting/acBankBalanceView',
    'opmenu-accounting',
    false
  )
];

const customerListMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Customer List',
    'Customer List',
    CustomerListNotSelectedIcon,
    CustomerListSkyBlue,
    //CustomerListSelectedIcon,
    '/common/joblistview/company/customer',
    'opmenu-customerList',
    false
  )
];

const referenceFilesMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Reference Files',
    'Reference Codes',
    ReferenceFilesNotSelectedIcon,
    ReferenceFilesNotSelectedIconSkyBlue,
    //ReferenceFilesHoverIcon,
    '/referenceFiles',
    'opmenu-referenceFiles',
    false
  )
];

const continerTrackingTxt = 'Orchid Tracking';
const ContainerTrackingItems: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    continerTrackingTxt,
    '',
    OrchidTrackingIcon,
    OrchidTrackingIconSkyBlue,
    //ContainerTrackIconWhite,
    '',
    'opmenu-containerTracking',
    false
  )
];

const UtilMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Util',
    constants.operations.utility,
    utilitiesIcon,
    utilitiesIconSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/utCommunication/utility',
    'opmenu-utilities',
    false
  )
];

const SetupMenuItems: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Settings',
    'Settings',
    SettingsNotSelectedIcon,
    SettingsNotSelectedIconSkyBlue,
    //SettingsHoverIcon,
    '/settings',
    'opmenu-settings',
    false
  )
];

const InbondMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'In-bond',
    '',
    inbondMenuIconBlue,
    inbondMenuIconSkyBlue,
    //utilitiesHoverIcon,
    '',
    'opmenu-in-bond',
    false
  )
];

const InbondMenuNotUse: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'In-bond',
    '',
    inbondMenuIconBlue,
    inbondMenuIconSkyBlue,
    //utilitiesHoverIcon,
    '',
    'opmenu-in-bond',
    true,
    inbondMenuIconGray
  )
];

const supportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'eSupport',
    '',
    supportIcon,
    supportIconSkyBlue,
    //supportHoverIcon,
    '',
    'opmenu-eSupport',
    false
  )
];

const BusinessIntelligenceMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Business Intelligence',
    'Business Intelligence',
    businessIntelligenceNotSelected,
    businessIntelligenceNotSelectedSkyBlue,
    //'',
    '/accounting/acBusinessIntelligence',
    'opmenu-bisunessIntenlligence',
    false,
  )
];

type IfmsTopBarProps = {
  onMenuItemClicked: (menuItem: IfmsConfigMenuItem) => void,
  systemSettings: SystemSettings | null,
  user: User | null,
  homeMenu?: Array<IfmsConfigMenuItem> | null | undefined,
  selectedOperation: string,
  menus: IfmsConfigOperationMenu | null | undefined,
  currentUrl: string,
  openNewPage: (link: string) => void,
  logout: () => Promise<void>,
  isLicenseeList?: boolean,
  showMainPop: boolean,
  setShowMainPop: React.Dispatch<React.SetStateAction<boolean>>,
};

let observer: MutationObserver | null = null;

const IfmsTopBar: React.FC<IfmsTopBarProps> = ({
  onMenuItemClicked,
  systemSettings,
  homeMenu,
  selectedOperation,
  menus,
  currentUrl,
  openNewPage,
  logout,
  user,
  isLicenseeList,
  showMainPop,
  setShowMainPop
}) => {
  const dispatch = useAppDispatch();
  const [displayOperation, setDisplayOperation] = useState<string>(selectedOperation);
  let standaloneTitleChangeSubscription = useRef<ISubscriptionDefinition<any> | null>(null);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<UserButtonItem | null>(null);
  const [searchType, setSearchType] = useState<string>('BL');
  const [searchText, setSearchText] = useState<string>(''); 
  const [isHoverSearchInput, setIsHoverSearchInput] = useState(false);
  const [isFocusSearchInput, setIsFocusSearchInput] = useState(false);
  const versionCount = useRef<number>(1);   

  //const lastHomeClickedFrom = useRef<string>('');

  const appContext = useContext(ApplicationContext);
  let grents = appContext.securityGrants;
  const configMenu = _.cloneDeep(config.menus);
  //const sSetupSec = appContext.securityGrants?.find(x=>x.securityTaskCode == FmsSecTask.SystemSetup);
  const compSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.CodeCompany);
  const myEventSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.MyEvent);
  const businessIntelligenceSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.BusinessIntelligence);
  //const enableMyEvent = appContext.suntekSettings?.general?.enableMyEvent?? false;
  const homeUrls = ['/', '/home', '/home/home'];
  const useDarkMode = appContext.useDarkMode;
  const { getSingleOpenedScreenInAnyOperationStartingWithUrl } = useJobMenus();
  const {setFilterForScreenExternally} = useExternalScreenFilter();

  // const MyEventMenu: Array<IfmsConfigMenuItem> = [
  //   createMenuItem(
  //     'My Event',
  //     constants.operations.myEvent,
  //     myjobNotSelected,
  //     myjobNotSelectedSkyBlue,
  //     '/common/joblistview/MYEVT/myEvent',
  //     'opmenu-myEvent',
  //     !enableMyEvent,
  //     myjobNotSelectedGray,
  //   )
  // ];

  const MyTaskMenu: Array<IfmsConfigMenuItem> = [
    createMenuItem(
      'My Task',
      '',
      myjobNotSelected,
      myjobNotSelectedSkyBlue,
      '',
      'opmenu-myTask',
      false,
    )
  ];

  //const goToHomeIconVisible = homeUrls.includes(currentUrl) && !homeUrls.includes(lastHomeClickedFrom.current) && !_.isEmpty(lastHomeClickedFrom.current);
  useEffect(() => {
    // alignReportMenus();

    let dopr = selectedOperation !== constants.operations.standalone
      ? selectedOperation
      : '';

    if (dopr !== displayOperation) {
      setDisplayOperation(dopr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperation]);

  useEffect(() => {
    initialize();

    return uninitialize;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function doLogout() {
    setSelectedPopupMenuItem(null);
    logout();
  }

  function subscribeChannels() {
    standaloneTitleChangeSubscription.current = postal.subscribe({
      channel: 'ifms',
      topic: 'ifms.standalone-title',
      callback: (title: string) => {
        setTimeout(() => {
          setDisplayOperation(title);
        }, 50);
      },
    });
  }

  function unsubscribeChannels() {
    if (standaloneTitleChangeSubscription.current) {
      postal.unsubscribe(standaloneTitleChangeSubscription.current);
    }
  }

  function initialize() {
    subscribeChannels();

    const targetNode = document.getElementById('ifms-top-bar');
    if (targetNode) {

      if (!observer) {
        const observerConfig = {
          attributes: true,
          childList: true,
          subtree: true,
        };

        observer = new MutationObserver(observe);
        observer.observe(targetNode, observerConfig);
      }

      /*if (!resizeObserver) {
        resizeObserver = new ResizeObserver(alignReportMenus);
        resizeObserver.observe(targetNode);
      }*/
    }
  }

  function uninitialize() {
    unsubscribeChannels();

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    /*if (resizeObserver) {
      resizeObserver.disconnect();
    }*/
  }

  function observe() {
    const topMenus = document.querySelectorAll('[data-submenuselected]');
    if (topMenus) {
      for (let i = 0; i < topMenus.length; i++) {
        const el = topMenus[i];
        if (el instanceof HTMLElement) {
          const selectedAttr = el.dataset.submenuselected;
          if (selectedAttr === 'true') {
            if (!el.classList.contains('rc-menu-submenu-selected')) {
              el.classList.add('rc-menu-submenu-selected');
            }
          } else {
            if (el.classList.contains('rc-menu-submenu-selected')) {
              el.classList.remove('rc-menu-submenu-selected');
            }
          }
        }
      }
    }
  }

  // const hasJob = !!menus && !!menus.job && menus.job.length > 0;
  // const hasDownload = !!menus && !!menus.download && menus.download.length > 0;
  // const hasReport = !!menus && !!menus.report && menus.report.length > 0;
  // const hasPreReport = !!menus && !!menus.preReport && menus.preReport.length > 0;
  // const hasAfterReport = !!menus && !!menus.afterReport && menus.afterReport.length > 0;
  // const hasOperationReport = !!menus && !!menus.operationReport && menus.operationReport.length > 0;

  // let userEmail = '';
  // if (user) {
  //   if (user.department) {
  //     userEmail = `${user.email} - ${user.departmentName}`;
  //   } else {
  //     userEmail = user.email ?? '';
  //   }
  // }

  function goToHome(callByLogo: boolean) {
    // if (goToHomeIconVisible) {
    //   if (!callByLogo) {
    //     let nextUrl = lastHomeClickedFrom.current;
    //     lastHomeClickedFrom.current = '';
    //     openNewPage(nextUrl);
    //   }
    // } else {
    // lastHomeClickedFrom.current = currentUrl;
    dispatch(changeOperation('Home'));
    openNewPage('/home/home');
    // }
  }

  async function goToAES() {
    var apiResult = await appContext.api.getAesLink();

    if(apiResult && apiResult.success) {
      window.open('https://aes.suntekscm.com/home/loginrequest/' + apiResult.result);
    }
  }

  function goToTaskReminderList(){
    if(appContext.systemSettings?.reminderStatus && !showMainPop) {setShowMainPop(true);}
  }

  async function goToInbond() {
    var apiResult = await appContext.api.getInbondLink()

    if(apiResult && apiResult.success) {
      window.open('https://inbond.suntekscm.com/Account/AutoLoginInBondFms?args=' + apiResult.result);
    }
  }

  async function goToSupport() {
    var apiResult = await appContext.api.getSupportLink()

    if(apiResult && apiResult.success) {
      window.open('http://bbs.suntekscm.com/Login.aspx?loginInfo=' + apiResult.result);
    }
  }

  async function goToISF() {
    var apiResult = await appContext.api.getIsfLink()

    if(apiResult && apiResult.success) {
      window.open('https://imanifest.suntekscm.com/Home/AutoLoginFms?args=' + apiResult.result);
    }
  }

  async function goToAMS() {
    var apiResult = await appContext.api.getAmsLink();

    if(apiResult && apiResult.success) {
      window.open('https://ams1.suntekscm.com/login_auto.aspx?' + apiResult.result);
    }
  }

  // function getDbNameWithSuntekId() {
  //   //<pt231216: [userid-login]
  //   //const authService = new AuthService();
  //   // const licProduct:LicProduct = authService.getUserLicProduct();

  //   // return `${licProduct.database_DBName??''} (${licProduct.licID})`;
  //   return user === null ? "" : <p>{user.defaultDatabase?.toUpperCase()??''}<br/>({user.suntekId})</p>;
  //   //pt231216>
  // }

  // const afterReport = config.reportManagerMenu;

  /*
    const onLinkClick = (link: string) => {
      setSelectedPopupMenuItem(null);
      
      if (link.includes('http'))
        window.open(link);
      else
        openNewPage(link)
    }
  
    function changeButton(_button: ButtonItem) {
      const newButton: IfmsConfigMenuItem =
      {
        text: _button.label,
        level: 0,
        metadata: _button.metadata,
        link: _button.link,
        changeOperation:'Utility',
        changeSideMenu:'Utility'
      }
      return newButton;
    }
  
    async function checkFileServer() {
      const apiResult2: ApiResult<InsertResultsWithData> = await appContext.api.checkfileserver();
      if (apiResult2 && apiResult2.success)
        await showGlobalOkDialog(<p>File Server is working!</p>);
      else
        await showGlobalOkDialog(<p>File Server is not working!</p>);
    }
  
    async function setMilestoneOption(jobName:string){
      if(jobName === 'OIH'){
        if(hasOpenedScreenStartingWithUrl('/common/joblistview/hbl/oceanImport')){
          await showGlobalOkDialog(<p>Please close HBL List (OI)</p>);
          return;
        }
        appContext.setSystemSettings({
          ...appContext.systemSettings,
          showMilestoneInOihList:!appContext.systemSettings?.showMilestoneInOihList,
        });
      }
      else{
        if(hasOpenedScreenStartingWithUrl('/common/joblistview/aiHawb/airImport')){
          await showGlobalOkDialog(<p>Please close HAWB List (AI)</p>);
          return;
        }
        appContext.setSystemSettings({
          ...appContext.systemSettings,
          showMilestoneInAihList:!appContext.systemSettings?.showMilestoneInAihList,
        });
      }
    }
  
    async function openESupportPage(){
      const openURL:string = await appContext.api.getESupportURL(fmsGlobal.AcmeID)
      window.open(openURL);
    }
    */

  // async function searchData(searchType: string, searchText: string){
  async function searchData(searchText: string){
    // const apiResult = await appContext.api.getSearchAllTable(searchType, searchText);
    const apiResult = await appContext.api.getSearchAllTable(searchText);
    if(apiResult && apiResult.success && apiResult.result){
      const searchType = apiResult.result.searchType;
      const tbName = apiResult.result.tbName;
      const tbId = apiResult.result.tbId;
      const showList = apiResult.result.showList;
      const hdType = apiResult.result.hdType;
      const id = apiResult.result.id;
      const refNo = apiResult.result.refNo;
      let detailUrl = '';
      let jobName = getJobNameByTbName(tbName);

      if(searchType === 'ACCT'){
        switch(hdType){
          case "T_INVOHD":
            if(tbName) jobName = JobNames.Invoice;
            else jobName = JobNames.GInvo;
            break;
          case "T_APHD":
            if(tbName) jobName = JobNames.Bill;
            else jobName = JobNames.GBill;
            break;
          case "T_CRDBHD":  
            jobName = JobNames.CrDb;
            break;
        }
      }
      if(showList){
          switchToList(jobName, searchText, searchType, showList, id, refNo, hdType);
      }else{
        detailUrl = getDetailUrlByJobName(jobName, tbId, tbName, id);

        let opType = getOpTypeConstant(jobName);

        const lastScreenQuery = getSingleOpenedScreenInAnyOperationStartingWithUrl(detailUrl);
        if (lastScreenQuery && lastScreenQuery.item) {
          // opertaion location update
          if (!opType) {
            opType = lastScreenQuery.operation;
          }

          // screen open
          dispatch(moveScreenToTop({
            url: detailUrl,
            operation: opType,
          }));
    
          // open page.
          NavOpenNewPage(history, detailUrl, NavigationType.jobMenuSwitch, 
            lastScreenQuery.item.metadata, 
            opType??lastScreenQuery.item.afterScreenUrl);
          return;
        }
        
        openNewPage(detailUrl);
      }
    }else{
      setSearchText("No Found Data");
      setTimeout(() => {
        const focusElement = document.getElementById("ifms-search-text") as HTMLInputElement;
        if (focusElement) {
          focusElement.focus();
          focusElement.select();
        }
      }, 100);
    }
  }

  function getDetailUrlByJobName(jobName: string, tbId: number, tbName: string = '', id: number = 0){
    switch(jobName){
      case JobNames.OIMbl:                    return `/oceanImport/mbl/view/${tbId}`;
      case JobNames.OIHbl:                    return `/oceanImport/hbl/view/${tbId}`;
      case JobNames.OEMbl:                    return `/oceanExport/mbl/view/${tbId}`;
      case JobNames.OEHbl:                    return `/oceanExport/hbl/view/${tbId}`;

      case JobNames.AIMbl:                    return `/airImport/mawb/view/${tbId}`;
      case JobNames.AIHbl:                    return `/airImport/hawb/view/${tbId}`;
      case JobNames.AEMbl:                    return `/airExport/mawb/view/${tbId}`;
      case JobNames.AEHbl:                    return `/airExport/hawb/view/${tbId}`;
      case JobNames.OtherOP:                  return `/otherShipment/otherShipment/view/${tbId}`;
      case JobNames.WHRcv:                    return `/warehousing/receiving/view/${tbId}`;
      case JobNames.WHShip:                   return `/warehousing/shipping/view/${tbId}`;
     
      case JobNames.Invoice:                  return `/accounting/invoice/view/${getJobNameByTbName(tbName)}/${tbId}/${id}`;
      case JobNames.GInvo:                    return `/accounting/acGeneralInvoice/view/${id}`;
      case JobNames.CrDb:                     return `/accounting/crdb/view/${getJobNameByTbName(tbName)}/${tbId}/${id}`;
      case JobNames.Bill:                     return `/accounting/bill/view/${getJobNameByTbName(tbName)}/${tbId}/${id}`;
      case JobNames.GBill:                    return `/accounting/acGeneralBill/view/${id}`;

      case JobNames.BTOrder:                  return `/brokerageTrucking/order/view/${tbId}`;
      case JobNames.BTLoadPlan:               return `/brokerageTrucking/loadPlan/view/${tbId}`;
      case JobNames.BTDo:                     return `/brokerageTrucking/localDO/view/${tbId}`; 

      
      default : return '';
    }
  }

  
  const history = useHistory();

  function switchToList(jobName: JobNames, searchText: string, searchType: string, showList: boolean, id:number , refNo: string, hdType: string) {
    let blType = '';
    let columnLabel = '';
    let columnId = '';
    let text = '';
    let columnIdEx: string | null = null;
    let textEx: string | null = null;
    let parentOp = false;
    let expressSearchCol = 'createdAt';
    switch(jobName) {
      case JobNames.OIMbl:
        blType = 'mbl';
        columnLabel = searchType === "CNTR" ? 'Container': 'MBL';
        columnId = searchType === "CNTR" ? 'containerNo' : 'mblNo';
        text= searchText;
        break;
      case JobNames.OIHbl:
        blType = 'hbl';
        if(searchType === "CNTR"){
          columnId = showList ? 'oiMblId' : 'cntrNo';
          columnLabel = showList ? 'Ref. #' : 'Container';
          columnIdEx = showList ? 'refNo' : null;
          text = showList ? id.toString() : searchText;
          textEx = showList ? refNo : null;
        }else{
          columnId = 'hblNo';
          columnLabel = 'HBL';
          text= searchText;
        } 

        break;
      case JobNames.OEMbl:
        blType = 'oeMbl';
        columnLabel = searchType == "CNTR" ? 'Container':'MBL';
        columnId =  searchType == "CNTR" ? 'containerNo' :'mblNo';
        text= searchText;
        break;
      case JobNames.OEHbl:
        blType = 'oeHbl';
        if(searchType === "CNTR"){
          columnId = showList ? 'oeMblId' : 'containerNo';
          columnLabel = showList ? 'Ref. #' : 'Container';
          columnIdEx = showList ? 'refNo' : null;
          text = showList ? id.toString() : searchText;
          textEx = showList ? refNo : null;
        }else{
          columnId = 'hblNo';
          columnLabel = 'HBL';
          text= searchText;
        } 
        break;
      case JobNames.AIMbl:
        blType = 'aiMawb';
        columnLabel = 'MAWB';
        columnId = 'mawbNo';
        text= searchText;
        break;
      case JobNames.AIHbl:
        blType = 'aiHawb';
        columnLabel = 'HAWB';
        columnId = 'hawbNo';
        text= searchText;
        break;
      case JobNames.AEMbl:
        blType = 'aeMawb';
        columnLabel = 'MAWB';
        columnId = 'mawbNo';
        text= searchText;
        break;
      case JobNames.AEHbl:
        blType = 'aeHawb';
        columnLabel = 'HAWB';
        columnId = 'hawbNo';
        expressSearchCol = 'u1Date';
        text= searchText;
        break;
      case JobNames.OtherOP:
        blType = 'otherShipment';
        if(searchType === "CNTR"){
          columnLabel = 'Container';
          columnId = 'container';
        }
        else{
          columnLabel = 'Ref.';
          columnId = 'refNo';
        }
        text= searchText;
        break;
      case JobNames.WHRcv:
        blType = 'whReceiving';
        columnLabel = 'Receiving ID';
        columnId = 'receiveNo';
        text= searchText;
        break;
      case JobNames.WHShip:
        blType = 'whShipping';
        columnLabel = 'Shipping ID';
        columnId = 'shipNo';
        text= searchText;
        break;
      case JobNames.Invoice:
          blType = 'invoice';
          columnLabel='Invoice #';
          columnId ='invoiceNo';
          parentOp = true;
          text= searchText;
          break;
      case JobNames.GInvo:
          blType = 'acGeneralInvoice';
          columnLabel='G.Invoice #';
          columnId ='invoiceNo';
          text= searchText;
        break;
      case JobNames.Bill:
          blType = 'bill';
          columnLabel='Bill #';
          columnId ='billNo';
          expressSearchCol = 'createdDate';
          parentOp = true;
          text= searchText;
        break;
      case JobNames.GBill:
          blType = 'acGeneralBill';
          columnLabel='G.Bill #';
          columnId ='billNo';
          expressSearchCol = 'createdDate';
          text= searchText;
        break;
      case JobNames.CrDb:  
        blType = 'crdb';
        columnLabel='Crdb #';
        columnId ='crDbNo';
        parentOp = true;
        expressSearchCol = 'u1Date';
        text= searchText;
        break;
      case JobNames.BTOrder:
        blType = 'btOrder';
        if(searchType === "CNTR"){
          columnId = 'containerNo';
          columnLabel ='Container #';
        } else if (searchType === "BL"){
          if(hdType === 'M'){
            columnId = 'mblNo';
            columnLabel = 'MBL';
          }else if (hdType === 'H'){
            columnId = 'hblNo';
            columnLabel = 'HBL';
          }
        }
        else{
          columnLabel = 'PRO #';
          columnId = 'orderNo';
        } 
        text = searchText;
        break;
      case JobNames.BTLoadPlan:
        blType = 'btLoadPlan';
        columnLabel = 'Load #';
        columnId = 'loadNo';
        text = searchText;
        break;
      case JobNames.BTDo:
        blType = 'btLocalDO';
        if(searchType === 'BL'){
          columnLabel = 'Ref #';
          columnId = 'refNo';
        }
        else{
          columnLabel = 'D/O #';
          columnId = 'doNo';
        }
        text = searchText;
        break;
      default:
        break;  
    }
    const opType = getOpTypeConstant(jobName);

    let model = new SearchModelBase();
    model.isExpressSearch = true;
    model.version = versionCount.current;  // Update version
    model.expressSearchCol = expressSearchCol;

    const link =`/common/joblistview/${blType}/${opType ? opType : 'accounting'}${parentOp ? '?parentOp=accounting': ''}`;
    setFilterForScreenExternally(
      link,
      columnId,
      columnLabel,
      text.toString(),
      'update',
      false,
      true,
      model,
      columnIdEx,
      textEx,
      true,
      true
    );

    versionCount.current += 1;

    openNewPage(link);
  }


  const OperationMenus: Array<IfmsConfigMenuItem> = [
    ...WarehousingMenu,
    ...OPReportMenu,
    ...BillingsMenu,
    ...AccountingMenu,
    ...customerListMenu,
    ...referenceFilesMenu,
    ...ContainerTrackingItems,
    ...SetupMenuItems,
    ...UtilMenu,
    ...InbondMenu,
    ...supportMenu,
  ];


  // for tabbar menu link setting.
  const filterMenuItems = (menuItems:IfmsConfigMenuItem[]) => {
    return _.cloneDeep(menuItems).filter(op => {
      let opSide = configMenu.find(cm => cm.operation === op.menuOp);
      if (opSide) {
        opSide.job = MenuFilterGrents(opSide.job, grents, appContext);
        if (opSide.job.length > 0) {
          if (opSide.job.find(x => x.link === op.link)) {
            return true;
          } else {
            op.link = opSide.job[0]?.link;
            return true;
          }
        }
      }
      return false;
    });
  };

  const filteredWarehousingMenu = filterMenuItems(WarehousingMenu);
  const filteredOrderMenu = filterMenuItems(OrderMenu);
  const filteredLoadMenu = filterMenuItems(LoadMenu);
  const filteredLocalDOMenu = filterMenuItems(LocalDOMenu);
  const filteredOPReportMenu = filterMenuItems(OPReportMenu);
  const filteredBillingsMenu = filterMenuItems(BillingsMenu);
  const filteredAccountingMenu = filterMenuItems(AccountingMenu);
  const filteredUtilMenu = filterMenuItems(UtilMenu);
  const filteredAMSMenu = filterMenuItems(AMSMenu);
  const filteredISFMenu = filterMenuItems(ISFMenu);

  return (
    <>
      <div id={!useDarkMode ? "ifms-app-common-bar" : "ifms-app-common-bar-darkmode"}>
        <div id='ifms-main-logo'>
          {/* <a style={{ cursor: homeUrls.includes(currentUrl) ? 'default' : 'pointer' }} onClick={() => goToHome(true)}><img src={!useDarkMode ? ifmsLogo : ifmsLogoWhite} alt="Suntek Systems - iFMS" width="90px" /></a> */}
          <a style={{ cursor: homeUrls.includes(currentUrl) ? 'default' : 'pointer' }} onClick={() => goToHome(true)}><div style={{fontWeight: 'bold', fontSize: '20px', color: useDarkMode ? '#B183B8' : 'purple'}}>Orchid CMS<sup>&reg;</sup></div></a>
          {/* {goToHomeIconVisible ?
              <img data-tooltip="Return to Last Tab" onClick={() => goToHome(false)} height="20px" width='20px' src={BackLastTabIcon} alt="Return to Last Tab" style={{ cursor: 'pointer', position: 'relative', top: '1px', left: '10px' }} />
              :
              ''
            } */}
          {/* <img src={!useDarkMode ? ifmsLogo : ifmsLogoWhite} alt="Suntek Systems - iFMS" width="90px" /> */}
        </div>
        <div className={'top-bar-menu-style'}>
          <div style={{ display: 'flex', fontSize: '12px' }}>
            {/* <DashboardMenu items={operMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} /> */}
            <div style={{ width: '130px' }}>
              <DashboardMenu items={filteredOrderMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '110px' }}>
              <DashboardMenu items={filteredLoadMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '130px' }}>
              <DashboardMenu items={filteredLocalDOMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '140px' }}>
              <DashboardMenu items={filteredWarehousingMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '140px' }}>
                <DashboardMenu items={filteredAMSMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '100px' }}>
                <DashboardMenu items={filteredISFMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '150px' }}>
              <DashboardMenu items={AESMenu} onMenuItemSelected={goToAES} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>

            <div style={{ width: '125px', display:'flex'}}>
                <DashboardMenu items={MyTaskMenu} onMenuItemSelected={goToTaskReminderList} selectedOperation={selectedOperation} currentUrl={currentUrl} />
                {["R","Y","G"].includes(appContext.systemSettings?.reminderStatus??'') &&  <img style={{ marginLeft:'7px', marginBottom:'5px'}} src={taskReminderIcon}></img>}
              </div>

            <div style={{ width: '125px' }}>
                <DashboardMenu items={InbondMenu} onMenuItemSelected={goToInbond} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
          </div>

          <div style={{ display: 'flex', fontSize: '11px' }}>
            <div style={{ width: '130px' }}>
              <DashboardMenu items={filteredOPReportMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '110px' }}>
              <DashboardMenu items={filteredBillingsMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '130px' }}>
              <DashboardMenu items={filteredAccountingMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            {(user?.isSuntekAdmin || compSec?.grantRead) &&
              <div style={{ width: '140px' }}>
                <DashboardMenu items={customerListMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
              </div>
            }
            <div style={{ width: '140px' }}>
              <DashboardMenu items={referenceFilesMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '100px' }}>
              <DashboardMenu items={filteredUtilMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            
            {(user?.isSuntekAdmin || businessIntelligenceSec?.grantRead) && 
              <div style={{ width: '150px' }}>
              <DashboardMenu items={BusinessIntelligenceMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />  
            </div>}
            
            <div style={{ width: '125px' }}>
              <DashboardMenu items={SetupMenuItems} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '125px' }}>
              <DashboardMenu items={supportMenu} onMenuItemSelected={goToSupport} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
          </div>
        </div>
        <TextBoxUncontrolled
          id={"ifms-search-text"} 
          noborder
          focusable={false}
          style={{display: 'flex', paddingLeft: '15px', width: '342px', height:'30px', borderRadius: '13px', background: isHoverSearchInput ? '#ACFFEF' : 'white', 
            /*boxShadow: appContext.useDarkMode ? '0px 0px 2px 2px #7F7F7F' : '0px 0px 2px 2px #7DB1BF',*/ 
            border: appContext.useDarkMode ? '2px solid #C3C3C3' : '2px solid #B4EBF6'}}
          maxLength={25} 
          value={searchText}
          onMouseOver={() => setIsHoverSearchInput(true)}
          onMouseLeave={() => setIsHoverSearchInput(false)}
          onEnter={async () => await searchData(searchText) }
          onChange={(e: any) => { setSearchText(e.target.value) }}
          onFocus={() => setIsFocusSearchInput(true)}
          onBlur={() => setIsFocusSearchInput(false)}
          placeholder={isFocusSearchInput ? '' : 'Enter PRO #, Load #, D/O #, B/L #, CNTR #, Billing #'}
        />
        <FontAwesomeIcon 
          color='#a1a1a1' 
          onClick={async () => await searchData(searchText) } 
          icon={faSearch} size={'1x'} 
          style={{position: 'relative', cursor: 'pointer', right: '28px'}} 
        />
        <div style={{ marginLeft: 'auto' }}>
   
          <UserButton
            items={[
              {
                label: 'Logout',
                icon: <img src={RunnerIcon} style={{ width: '16px', height: '16px' }} alt="" />,
                icon2: <img src={ExitIcon} style={{ width: '20px', height: '20px' }} alt="" />,
                separator: false
              }
            ]}
            onItemSelected={(event) => setSelectedPopupMenuItem(event)}
            user={user}
          >
          </UserButton>
          {!!selectedPopupMenuItem && selectedPopupMenuItem.label === 'Logout' ? doLogout() : null}
        </div>
        {systemSettings?.enableBranch && user?.branch &&
          <span style={{ fontSize: '11px', marginLeft: '5px', color: useDarkMode ? 'white' : 'black' }}>{user?.branch ?? ''}</span>
        }
      </div>
    </>
  );
};


export default IfmsTopBar;
